import type { StorageAdapter } from '@vestolio/app'

/**
 * Web storage adapter using localStorage.
 * Used by the shared API client on the web platform.
 */
export const webStorage: StorageAdapter = {
  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key)
  },

  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value)
  },

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key)
  },
}